export type ENV_NAME = "DEV" | "DEMO" | "PROD";

export enum ENV_FULL_NAME {
  DEV = "develop",
  DEMO = "demo",
  PROD = "production",
}
